/* eslint-disable max-len */
import React, {useEffect, useState, useRef} from 'react'
import {connect} from 'react-redux'
import Helpers from '../Helpers.js'

// Actions
import {storePayload} from '../actions/storePayload'

// Components
import {Icon, Slider} from '@lazarusai/forms-ui-components'
import {Document, Page, pdfjs} from 'react-pdf'

// React-PDF styles needed to remove warnings
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'

// Styles
import stylesIndex from '../index.module.css'
import stylesView from '../styles/View.module.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

function PdfRender(props) {
  const [isPdfRendering, setIsPdfRendering] = useState(true)
  const [rotations, setRotations] = useState(0)
  const [pageNumber, _setPageNumber] = useState(1)
  const pageNumberInputRef = useRef(1)
  const [pageNumberInput, _setPageNumberInput] = useState(1)
  const pageNumberInputElRef = useRef()
  const [newDocPageCount, setNewDocPageCount] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [renderCounter, setRenderCounter] = useState(0)
  const pageNumberRef = useRef(pageNumber)
  function setPageNumber(data) {
    _setPageNumber(data)
    pageNumberRef.current = data
  }

  function setPageNumberInput(data) {
    _setPageNumberInput(data)
    pageNumberInputRef.current = data
  }

  function onFocusOut() {
    if (pageNumberInputRef.current !== pageNumberRef.current) {
      onChangePageNum(pageNumberRef.current)
    }
  }

  // Revert pageNumberInput back to valid number
  useEffect(() => {
    if (pageNumberInputElRef.current) {
      pageNumberInputElRef.current.removeEventListener('focusout', onFocusOut)
      pageNumberInputElRef.current.addEventListener('focusout', onFocusOut)
    }
  }, [pageNumberInputElRef])

  const fileIndex = 0 // file index placeholder


  function onChangePageNum(num) {
    setPageNumberInput(num)
    const newPageNum = parseInt(num)
    if (newPageNum > 0 && newPageNum <= newDocPageCount) {
      setPageNumber(newPageNum)
    }
  }

  useEffect(() => {
    if (props.file) {
      setIsPdfRendering(false)
      onChangePageNum(1)
      setRotations(0)
      setZoom(1)
    }
  }, [props.file])

  function initiateDrawBoxes(noRenderUpdate=false) {
    if (
      (props.formsResponses?.[props.selectedFileIndex]?.ocrResults?.readResults ||
        (props.srcHeight && props.srcWidth)
      ) && // needed for dimensions
      props.pagesData?.[props.selectedFileIndex]?.[pageNumber]?.values?.length > 0
    ) {
      if (!noRenderUpdate) {
        setRenderCounter((renderCounter + 1)%5)
      }
      const drawBoxesProps = {
        res: props.formsResponses[props.selectedFileIndex],
        file: props.file,
        pagesData: props.pagesData[props.selectedFileIndex],
        pageNumber: pageNumberRef.current,
        fileIndex,
        rotations,
        zoom,
        srcHeight: props.srcHeight,
        srcWidth: props.srcWidth,
        // srcHeight: props.srcHeight * 4.125,
        // srcWidth: props.srcWidth * 4.125,
      }
      Helpers.drawBoxes(drawBoxesProps)
    }
  }

  useEffect(() => {
    makeDocLinksOpenTab()
  }, [props.selectedModel])

  // for some reason, boxes aren't drawn without a delay even though it seems the canvas is rendered
  // useEffect(() => {
  //   setTimeout(() => {
  //     initiateDrawBoxes()
  //   }, [500])
  // }, [props.selectedFileIndex])

  function onDocumentLoadSuccess(res) {
    setIsPdfRendering(true)
    if (res && res.numPages) {
      setNewDocPageCount(res?.numPages)
    }
  }

  function onPageRenderSuccess(res) {
    // props.storePayload({
    //   srcHeight: res.originalHeight,
    //   srcWidth: res.originalWidth,
    // })
    makeDocLinksOpenTab() // update links when page loads
    initiateDrawBoxes(true)
  }

  // gets all the urls and adds the properties to make them open in a new tab
  function makeDocLinksOpenTab() {
    const pdfLinks = document.getElementById('image-container').getElementsByTagName('a')
    for (let i=0; i<pdfLinks.length; i++) {
      pdfLinks[i].setAttribute('target', '_blank')
      pdfLinks[i].setAttribute('rel', 'noopener noreferrer')
    }
  }

  return (
    <div className={stylesView['render-container']}>
      <div
        className={`${stylesView['arrow']} ${stylesView['arrow-left']}`}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          if (pageNumberInputRef.current - 1 > 0) {
            onChangePageNum(pageNumberInputRef.current - 1)
          }
        }}
      >
        {
          props?.file?.type === 'application/pdf' && pageNumber > 1 ?
            <Icon
              icon={'arrow-circle-left-outline'}
              key={'arrow-left'}
              animation={null}
            /> :
            <Icon
              className={
                `${stylesIndex['disabled']}`
              }
              icon={'arrow-circle-left-outline'}
              key={'arrow-left-disabled'}
              animation={null}
            />
        }
      </div>
      <div
        className={`${stylesView['arrow']} ${stylesView['arrow-right']}`}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          if (pageNumberInputRef.current + 1 <= newDocPageCount) {
            onChangePageNum(pageNumberInputRef.current + 1)
          }
        }}
      >
        {
          props?.file?.type === 'application/pdf' && pageNumber < newDocPageCount ?
            <Icon
              icon={'arrow-circle-right-outline'}
              key={'arrow-right'}
              animation={null}
            /> :
            <Icon
              className={
                `${stylesIndex['disabled']}`
              }
              icon={'arrow-circle-right-outline'}
              key={'arrow-right-disabled'}
              animation={null}
            />
        }
      </div>
      <div className={`${stylesView['zoom']}`}>
        <Slider
          type={4}
          theme={'dark'}
          onChangeZoom={(e) => {
            const val = parseInt(e.target.value)
            setZoom(3 ** (val/50) / 3)
          }}
        />
      </div>
      <div
        className={`${stylesView['rotate-icon']}`}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setRotations((rotations + 1) % 4)
        }}
      >
        <Icon
          icon={'refresh-outline'}
          key={'rotate-icon'}
        />
      </div>
      {props?.file?.type === 'application/pdf' &&
            <div className={`${stylesView['page-number-pill']}`}>
              <span className={`${stylesView['page-number-pill-span']}`}>
                <input
                  className={stylesView['page-number-input']}
                  onChange={(e) => onChangePageNum(e.target.value)}
                  value={pageNumberInput}
                  type='number'
                  max={newDocPageCount}
                  min={'1'}
                  width='auto'
                  ref={pageNumberInputElRef}
                />
                <span>/</span>
                <span>{newDocPageCount}</span>
              </span>
            </div>
      }
      <div id={props.alternate_id || 'image-container'} className={stylesView['image-container']}>
        {props.file &&
            <div
              id={'pdf-keyValuePairs' + fileIndex}
              style={{width: '100%'}}
            >
              <div id='pdf-main'>
                <div id='pdf-view' className={`${stylesIndex['auto-pointer-event']}`}>
                  <Document
                    file={props.file}
                    onLoadSuccess={onDocumentLoadSuccess}
                    // onLoadError={console.error}
                  >
                    <div
                      key={`pdf-page-${pageNumber}-${renderCounter}`}
                      className={true ? `${stylesIndex['visible']}` : `${stylesIndex['invisible']}`}
                      // onClick={onFileClick}
                    >
                      {isPdfRendering && <Page
                        pageNumber={pageNumber}
                        width={
                          document.getElementById(props.alternate_id || 'image-container') ?
                            document.getElementById(props.alternate_id || 'image-container').clientWidth * zoom :
                            0
                        }
                        onRenderSuccess={onPageRenderSuccess}
                        onLoadError={console.error}
                        rotate={rotations * 90}
                      />}
                    </div>
                  </Document>
                </div>
              </div>
            </div>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  pagesData: state.userReducer.pagesData,
  dataRender: state.userReducer.dataRender,
  selectedModel: state.userReducer.selectedModel,
  srcHeight: state.userReducer.srcHeight,
  srcWidth: state.userReducer.srcWidth,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(PdfRender)

